import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import InvoiceForm from "./InvoiceForm";

const InvoiceAdd = () => {
    return (
        <Fragment>
            <InvoiceForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default InvoiceAdd;